import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { learnMoreClicked } from '../../../redux/actions/bi.actions';
import { generateInvitePeopleLearnMoreLink } from '../../../consts/external-links';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { Text } from 'wix-style-react';

interface IPageSubtitleComponentProps extends InjectedTranslateProps {
  locale: string;
  isSite: boolean;
}

const PageSubtitleComponent = ({ t, locale, isSite }: IPageSubtitleComponentProps) => {

  const dispatch = useDispatch();

  const clickLearnMoreAction = useCallback(() => {
    dispatch(learnMoreClicked('/invite'));
  }, [dispatch]);

  return (
    <div>
      {`${t(`${isSite ? 'site.' : ''}app.invitePeopleToYourWix`)} `}
      <Text>
        <a
          data-hook="team-management-learn-more-link"
          onClick={clickLearnMoreAction}
          target="_blank"
          href={generateInvitePeopleLearnMoreLink(isSite, locale)}>
          {t('app.invitePeopleToYourWix.link')}
        </a>
      </Text>
    </div>
  );
};

export const PageSubtitle = translate()(PageSubtitleComponent);
